
{
  "actions": {
    "edit": "Edit",
    "delete": "Delete"
  }
}
